import React from 'react'
import { useNavigate } from 'react-router';
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MdArrowForward } from "react-icons/md";
import CargoNotif from '../../../../home/images/cargoNotif.png';
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import { CiHeart } from "react-icons/ci";
import { gregorianToJalali } from '../../../../../utiels/functions/persianFormat';
import { timeAgo } from '../../../../../utiels/functions/persianFormat';
import { FaHeart } from 'react-icons/fa';
import CargoService from '../../../../../services/Cargo';
import DriverService from '../../../../../services/Driver';
import { showToast } from '../../../../../redux/slices/toastSlice';
import { useDispatch } from 'react-redux';


export default function CargoModals({ cargos,render }) {
    const [isMobile, setIsMobile] = useState(false);
    // const [showAll, setShowAll] = useState(false);


    const navigate = useNavigate()
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);





    return (



        <div className="w-full min-h-[80vh] overflow-y-auto ">
            <div className="grid gap-6 grid-cols-1 pb-5  min-h-full overflow-y-auto sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
                {cargos.map((cargo, index) => (
                    <motion.div

                        key={index}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.06 }}
                        className="w-full"
                    >
                        <CardCargoInfo
                            typeOfCar={cargo?.car?.label}
                            timeOfCargo={cargo.deliveryDate}
                            timeOfCreate={cargo.createdAt}
                            origin={(cargo.origin?.state?.name || cargo.origin?.country?.name) + "," +cargo.origin?.name }
                            dest={(cargo.destination?.state?.name || cargo.destination?.country?.name) + "," +cargo.destination?.name }
                            id={cargo._id}
                            isSaved={cargo?.isSaved}
                            request_status={cargo?.request_status
                            }
                            render={render}
                       

                        />
                    </motion.div>
                ))}
            </div>
        </div>





    );
}




function CardCargoInfo({ typeOfCar, timeOfCargo, timeOfCreate, origin, dest, id, isSaved,request_status ,render}) {
    const navigate = useNavigate()
    const [loadingBtn,setLoadingBtn]=useState(false)

    const dispatch=useDispatch()

   async function handleOnCardClick(id) {
   
            try{
              setLoadingBtn(true)
              const body={
                id:id
              }
              const res=await DriverService.removerCargo(body)
             await render()
              dispatch(showToast({message:"بار با موفقیت حذف شد",type:"success"}))
            }catch(err){
              dispatch(showToast({message:err?.data?.resdata?.message|| "خطا در حذف بار",type:"error"}))
              console.log(err)
            }finally{
              setLoadingBtn(false)
            }
          
    }

    return (
        <div className="rounded-[30px] hover:translate-y-1 transition duration-200 text-special
      w-full  bg-white border-[1px] border-gray-200  h-max
      shadow-md flex flex-col justify-between items-center
      px-1 py-4 ">

            {/* header */}
            <div className="flex justify-between w-full h-max lg:px-8 px-5">
                <div className="flex flex-row gap-4 items-center text-gray-900 w-auto">
                    <img className="w-[35px]" src={CargoNotif} />
                    <p className="lg:text-[12px] text-[10px]">{typeOfCar}</p>

                </div>

                <div className="flex flex-row gap-2 w-auto overflow-hidden  items-center">
                    <div className={`text-center rounded-lg flex items-center justify-center w-[80px] h-[30px] py-1 ${request_status==="pending" && 'bg-[#0075FF0D]' || request_status==="accepted" && 'bg-green-200' || request_status==="canceled" && 'bg-red-400'  } `}>
                        <p className={`text-blue-950 lg:text-[12px] text-[10px] ${ request_status==="accepted" && 'text-green-700' || request_status==="canceled" && 'bg-red-700'  }`}> {request_status==="pending" && 'در انتظار تایید' || request_status==="accepted" && 'تایید شده' || request_status==="canceled" && 'رد شده'  }</p>
                    </div>
                </div>

            </div>

            {/* body */}
            <div className="h-1/3 flex flex-col w-full justify-center items-center lg:py-7 py-4  lg:px-8 px-5 ">

                <div className="flex flex-col items-start justify-center  text-start  w-full ">

                    <p className="lg:text-[16px] text-[14px] text-gray-400 truncate"
                        title={origin}>مبدا: {origin}</p>
                    <p className="lg:text-[16px] text-[14px] text-gray-400 truncate"
                        title={dest}>مقصد: {dest}</p>
                    <p className='lg:text-[16px] text-[14px] text-gray-400'>بارگیری: {gregorianToJalali(timeOfCargo)}</p>



                </div>
            </div>

            <div className="w-full px-5 gap-2 flex justify-center">

                <button disabled={loadingBtn} onClick={() => { handleOnCardClick(id) }} className={`w-[30%] ${loadingBtn && 'transition duration-200 trnaslate-y-10'} flex justify-center whitespace-nowrap  lg:text-[16px] text-[14px]  rounded-[12px] lg:1/4 h-[40px] bg-white  text-red-600 hover:text-white hover:bg-red-500 border-[1px] border-red-600 text-center lg:px-10 py-2`}>
                    {
                        loadingBtn?
                        'در حال حذف...'
                        :
                        'لغو'

                    }

                </button>
                <button onClick={() => { navigate(`/driver/cargo/${id}`) }} className={`w-[60%] flex justify-center whitespace-nowrap  lg:text-[16px] text-[14px]  rounded-[12px] lg:1/4 h-[40px] bg-white  text-special hover:text-white hover:bg-special border-[1px] border-special text-center lg:px-10 py-2`}>
                    نمایش جزییات
                </button>
            </div>
        </div>
    );
}

